import { render, staticRenderFns } from "./biddingProject.vue?vue&type=template&id=693e5bb2&scoped=true&"
import script from "./biddingProject.vue?vue&type=script&lang=js&"
export * from "./biddingProject.vue?vue&type=script&lang=js&"
import style0 from "./biddingProject.vue?vue&type=style&index=0&id=693e5bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693e5bb2",
  null
  
)

export default component.exports